import IMask from "imask";
import Swal from "sweetalert2";
import { initAllCustomSelects } from "./custom-select";

let form = document.querySelector(".form-register");
let dataOptions = document.querySelectorAll("[data-option]");
let telefonos = document.querySelectorAll("[data-tel]");

const getBrowserName = () => {
    if (navigator.brave != undefined) return "Brave Browser";
    if (navigator.userAgent.indexOf("Edg") != -1) return "Microsoft/Edge";
    if (navigator.userAgent.indexOf("Firefox") != -1) return "Mozilla Firefox";
    if (navigator.userAgent.indexOf("OPR") != -1) return "Opera Browser";
    if (navigator.userAgent.indexOf("Chrome") != -1) return "Google Chrome";
    if (navigator.userAgent.indexOf("Safari") != -1) return "Safari";
    return "Navegador Desconocido";
};

const getPlatform = () => {
    if (navigator.userAgent.indexOf("Win") != -1) return "Windows";
    if (navigator.userAgent.indexOf("Android") != -1) return "Android OS";
    if (navigator.userAgent.indexOf("Linux") != -1) return "Linux";
    if (navigator.userAgent.indexOf("Mac") != -1) return "Mac OS";
};

let checkFormIsValid = function (form) {
    let formElements = form.querySelectorAll("[data-required]");
    let nroVal = 0;
    formElements.forEach(function (el) {
        // A disabled field is never sent by FormData, so it can't be the
        // thing blocking submission — e.g. a "nombre de iglesia" field left
        // over from before an existing church was picked from the select.
        if (el.disabled) {
            ++nroVal;
            return;
        }
        let labelError = el.parentElement.querySelector("span");
        if (
            el.dataset.valid == "true" ||
            (el.value != "" && el.value != undefined)
        ) {
            ++nroVal;
        } else {
            el.classList.add("required");
            if (labelError != undefined) labelError.classList.add("show");
        }
    });

    if (nroVal >= formElements.length) {
        return true;
    }
    return false;
};

let validateForm = function (form) {
    let formElements = form.querySelectorAll(
        "[data-required], .required, .form-control"
    );
    formElements.forEach(function (element) {
        let labelError = element.parentElement.querySelector("span");

        element.addEventListener("focus", function () {
            if (labelError != undefined) labelError.classList.remove("show");
            element.classList.remove("required");
            return true;
        });

        element.addEventListener("blur", function () {
            if (element.value != "") {
                element.classList.remove("required");
                if (labelError != undefined)
                    labelError.classList.remove("show");
                element.classList.add("success");
                element.setAttribute("data-valid", "true");
                return true;
            }
            element.classList.remove("success");
            element.classList.add("required");
            element.removeAttribute("data-valid");
            if (labelError != undefined) labelError.classList.add("show");
            return true;
        });
        return false;
    });
};

dataOptions.forEach(function (element, i) {
    let checkbox = element.querySelector('input[type="checkbox"]');
    let inputs = element.querySelectorAll('input[type="text"]');
    checkbox.addEventListener("change", function () {
        if (checkbox.checked) {
            checkbox.value = "on";
            blockNextInput(dataOptions, element);
            enableInputs(element);

            if (inputs != undefined) {
                inputs.forEach(function (input) {
                    input.setAttribute("data-required", "");
                    input.classList.add("required");
                });
            }
            return;
        }
        blockNextInput(dataOptions, element);
        disableInputs(element);
        return;
    });
});

form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (!checkFormIsValid(form)) {
        return false;
    }

    let platform = document.querySelector("[data-platform]");
    let browser = document.querySelector("[data-browser]");
    platform.value = getPlatform();
    browser.value = getBrowserName();

    let submitBtn = form.querySelector('[type="submit"]');
    let originalText = submitBtn.textContent;
    submitBtn.textContent = 'Enviando...';
    submitBtn.setAttribute('disabled', '');

    let token = form.querySelector('[name="_token"]').value;
    let formData = new FormData(form);

    fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': token,
        }
    })
    .then(function (response) {
        return response.json().then(function (data) {
            return { status: response.status, body: data };
        });
    })
    .then(function (result) {
        if (result.status === 200 && result.body.redirect) {
            window.location.href = result.body.redirect;
            return;
        }

        submitBtn.removeAttribute('disabled');
        submitBtn.textContent = originalText;

        let errorMsg = 'Ocurrió un error. Por favor intenta de nuevo.';
        if (result.body.message) {
            errorMsg = result.body.message;
        } else if (result.body.errors) {
            errorMsg = Object.values(result.body.errors).flat().join('<br>');
        }

        Swal.fire({
            icon: 'error',
            title: 'Error',
            html: errorMsg,
            confirmButtonText: 'Entendido',
        });
    })
    .catch(function () {
        submitBtn.removeAttribute('disabled');
        submitBtn.textContent = originalText;
        Swal.fire({
            icon: 'error',
            title: 'Error de conexión',
            text: 'No se pudo enviar el formulario. Verifica tu conexión e intenta de nuevo.',
            confirmButtonText: 'Entendido',
        });
    });
});

function cleanData(parent) {
    let elements = parent.querySelectorAll("input");
    elements.forEach(function (el) {
        el.value = "";
    });
    let selects = parent.querySelectorAll("select");
    selects.forEach(function (select) {
        if (select.value !== "") {
            select.value = "";
            select.dispatchEvent(new Event("change", { bubbles: true }));
        }
    });
}

function blockNextInput(arrOfInputs, currentEl) {
    arrOfInputs.forEach(function (nextEl) {
        if (currentEl != nextEl) {
            nextEl.classList.toggle("blocked");
            cleanData(nextEl);
        }
    });
}

function enableInputs(parent) {
    let elements = parent.querySelectorAll('input[type="text"], select');
    elements.forEach(function (el) {
        el.removeAttribute("disabled");
    });
}

function disableInputs(parent) {
    let elements = parent.querySelectorAll('input[type="text"], select');
    elements.forEach(function (el) {
        el.setAttribute("disabled", "");
        el.classList.remove("required");
        el.classList.remove("success");
        el.removeAttribute("data-valid");
        el.removeAttribute("data-required");
    });
}

telefonos.forEach(function (tel) {
    let maskOptions = {
        mask: "0000-000-00-00",
    };
    let mask = IMask(tel, maskOptions);
});

initAllCustomSelects();
validateForm(form);
